<header
  mat-dialog-title
  data-automation-id="content-node-selector-title">{{data?.title}}
</header>

<mat-dialog-content>
  <wk-content-node-selector-panel
    [currentFolderId]="data?.currentFolderId"
    [dropdownHideMyFiles]="data?.dropdownHideMyFiles"
    [dropdownSiteList]="data?.dropdownSiteList"
    [rowFilter]="data?.rowFilter"
    [imageResolver]="data?.imageResolver"
    [isSelectionValid]="data?.isSelectionValid"
    [breadcrumbTransform]="data?.breadcrumbTransform"
    [excludeSiteContent]="data?.excludeSiteContent"
    [where]="data?.where"
    (select)="onSelect($event)">
  </wk-content-node-selector-panel>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-button
    (click)="close()"
    data-automation-id="content-node-selector-actions-cancel">{{ 'NODE_SELECTOR.CANCEL' | translate }}
  </button>

  <button mat-button
          [disabled]="!chosenNode"
          class="adf-choose-action"
          (click)="onClick()"
          data-automation-id="content-node-selector-actions-choose">{{ buttonActionName | translate }}
  </button>
</mat-dialog-actions>
